"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _card = _interopRequireDefault(require("antd/lib/card"));

var _progress = _interopRequireDefault(require("antd/lib/progress"));

var _react = _interopRequireDefault(require("react"));

require("./progressStatCard.scss");

const ProgressStatCard = props => {
  const {
    color,
    count,
    subTitle,
    title,
    total
  } = props;
  const percentage = Math.round(count / total * 100);
  return /*#__PURE__*/_react.default.createElement(_card.default, {
    className: "hmp-progress-stat-card"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "header"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "title"
  }, title), /*#__PURE__*/_react.default.createElement("span", {
    className: "count",
    style: {
      color
    }
  }, count)), /*#__PURE__*/_react.default.createElement("div", {
    className: "sub-title"
  }, subTitle), /*#__PURE__*/_react.default.createElement(_progress.default, {
    className: "progress-bar",
    percent: percentage,
    strokeColor: color
  }));
};

var _default = ProgressStatCard;
exports.default = _default;